export default __webpack_public_path__ + "static/media/img-39.524410dd.jpg";